/**
 * 视频加载完成后回调
 */
'use strict';
angular.module("videoCanPlayModule", [])
    .directive("videoCanPlay", ['$compile', '$q', function($compile, $q) {
        return {
            resplace: false,
            restrict: "A",
            scope: false,
            link: function(scope, $elem, $attrs) {
                var $loadingDom;
                init();

                function init() {
                    $loadingDom = $compile($('<div cg-busy="videoLoadingPromise"></div>'))(scope);
                    $loadingDom.insertAfter($elem);
                    $elem.parent().addClass('videoLoading');
                    scope.videoLoadingPromise = loadingVideo();
                }
                /**
                 * [loadingVideo description] 加载音视频
                 * @return {[type]} [description]
                 */
                function loadingVideo() {
                    var deffer = $q.defer();
                    $elem[0].oncanplaythrough = function() {
                        deffer.resolve();
                        $loadingDom.remove();
                    };
                    return deffer.promise;
                }
            }
        };
    }]);